/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListRestart = [
  ["path", { d: "M21 5H3" }],
  ["path", { d: "M7 12H3" }],
  ["path", { d: "M7 19H3" }],
  ["path", { d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14" }],
  ["path", { d: "M11 10v4h4" }]
];

export { ListRestart as default };
//# sourceMappingURL=list-restart.js.map
